import React, { PureComponent } from 'react';
import UIUtils from '../../../../lib/UIUtils';
import { CONNECTION_CATEGORY_FILE } from '../../../../constants/connectionCategories';

import ConfigurationFields from '../../../elements/configViews/ConfigurationFields';

class FileSourceConfiguration extends PureComponent {
  render() {
    const { resourceId, config } = this.props;

    const sourceLocation = UIUtils.getLocationFromSourceConfig(
      config,
      'file',
      false,
      null,
      resourceId,
    );

    return (
      <div>
        <div className="detail-row single-col">
          <div className="detail-col">
            <div className="detail-key">Data Location</div>
            <div className="detail-value">{sourceLocation}</div>
          </div>
        </div>
        <ConfigurationFields {...this.props} connectionCategory={CONNECTION_CATEGORY_FILE} />
      </div>
    );
  }
}

export default FileSourceConfiguration;
